import { PILLARS } from "../data/content";
import { LogoMark } from "./Logo";

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {PILLARS.map((p) => (
      <span key={p} className="flex items-center">
        <span className="font-display font-black italic text-3xl sm:text-5xl tracking-tight text-[#0B0C10] whitespace-nowrap px-6 sm:px-10">{p}</span>
        <LogoMark dark className="h-7 w-7 sm:h-9 sm:w-9" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section id="operations" data-testid="pillars-marquee" className="relative bg-[#FF6B00] py-6 sm:py-8 overflow-hidden">
    <div className="flex w-max animate-marquee">
      <Row />
      <Row hidden />
    </div>
  </section>
);
